import Box from "@mui/material/Box";
import {firstMatchRange} from "../model/search";

/*
    The chip is already bold (`variableChipSx.fontWeight: 700`), so a bold match inside it is
    invisible; there the match is underlined instead. Plain text keeps the bold.
 */
const EMPHASIS_SX = {
    bold: {fontWeight: 700},
    underline: {textDecoration: "underline", textUnderlineOffset: "2px"},
} as const;

interface HighlightedTextProps {
    text: string;
    query: string;
    emphasis?: keyof typeof EMPHASIS_SX;
}

/** The first case-insensitive match of the query, emphasised. */
export function HighlightedText({text, query, emphasis = "bold"}: HighlightedTextProps) {
    const range = firstMatchRange(text, query);

    if (!range) return <>{text}</>;

    const [start, end] = range;

    return (
        <>
            {text.slice(0, start)}
            <Box component="span" sx={EMPHASIS_SX[emphasis]}>{text.slice(start, end)}</Box>
            {text.slice(end)}
        </>
    );
}

export default HighlightedText;
